import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Badge, Checkbox } from 'antd';
import { formatCurrency } from 'app/lib/utils/currency';
import { renderLoader } from 'app/lib/utils/adaya/AdayaUtils';
import { orZero } from 'app/lib/utils/NumUtils';
import React, { useState } from 'react';
import { ProviderNames } from 'lib/data/models/Providers';
import utmIconFACEBOOK from 'static/images/v2/facebook_icon.svg';
import utmIconGOOGLE from 'static/images/v2/google_icon.svg';
import utmIconTIKTOK from 'static/images/v2/tiktok_icon.svg';
import utmIconUnknown from 'static/images/v2/unknown_icon.svg';
import { columns } from './constants';

const getKey = (type, data) => {
    if (type === 'campaigns') return `${data.id}+${data.name}`;
    if (type === 'adsets') return data.id;
    if (type === 'ads') return data.id;
};

const renderRow = (activeTab, type, data, key, expandList, setExpandList, tickedList, setTickedList, idx) => {
    const handleCheck = (e) => {
        e.stopPropagation();
        let tempList = JSON.parse(JSON.stringify(tickedList));
        if (tempList[key]) tempList[key] = false;
        else tempList[key] = true;
        setTickedList(tempList);
    };

    const handleExpand = (e) => {
        let tempList = JSON.parse(JSON.stringify(expandList));
        if (tempList[key]) tempList[key] = false;
        else tempList[key] = true;
        setExpandList(tempList);
    };

    const providerImg =
        data.provider === ProviderNames.FACEBOOK
            ? utmIconFACEBOOK
            : data.provider === ProviderNames.GOOGLE
            ? utmIconGOOGLE
            : data.provider === ProviderNames.TIKTOK
            ? utmIconTIKTOK
            : utmIconUnknown;

    return (
        data && (
            <>
                <tr
                    className={
                        type === 'campaigns' ? (activeTab === 'campaigns' && tickedList[key] ? 'campaign-row-sel' : 'campaign-row') : type === 'adsets' ? 'adset-row' : 'ad-row'
                    }>
                    {type === 'campaigns' && (
                        <>
                            <td className={`utm-source view-on-desktop`}>
                                <img src={providerImg} height="100%" width="100%" alt={data.provider.toUpperCase()} />
                            </td>
                            <td id="title" className="campaign-box view-on-desktop" onClick={handleExpand}>
                                <div>
                                    {activeTab === 'campaigns' && <Checkbox checked={tickedList[key]} onClick={handleCheck}></Checkbox>}
                                    {data.isActive ? <Badge status="success" /> : <Badge status="default" />}
                                    {data.name}
                                </div>
                                {activeTab === 'campaigns' && (expandList[key] ? <CaretUpOutlined className="expand-btn" /> : <CaretDownOutlined className="expand-btn" />)}
                            </td>
                            <td className={`utm-source view-on-mobile`} rowSpan="2">
                                <img src={providerImg} height="93" width="37" alt={data.provider.toUpperCase()} />
                            </td>
                            <td id="title" className={`campaign-box view-on-mobile`} colSpan="3" onClick={handleExpand}>
                                <div>
                                    {activeTab === 'campaigns' && <Checkbox checked={tickedList[key]} onClick={handleCheck}></Checkbox>}
                                    {data.isActive ? <Badge status="success" /> : <Badge status="default" />}
                                    {data.name}
                                </div>
                            </td>
                            <td className="view-on-mobile" colSpan="10" style={{ padding: 0, height: 0 }}></td>
                        </>
                    )}
                    {type === 'adsets' && (
                        <>
                            <td id="title" className="adset-box view-on-desktop" colSpan="2" onClick={handleExpand}>
                                <div className="adsets-wrapper">
                                    <div>
                                        {activeTab !== 'ads' && <Checkbox checked={tickedList[key]} onClick={handleCheck}></Checkbox>}
                                        {data.name}
                                    </div>
                                    {activeTab !== 'ads' && (expandList[key] ? <CaretUpOutlined className="expand-btn" /> : <CaretDownOutlined className="expand-btn" />)}
                                </div>
                            </td>
                            <td id="utm" className="view-on-mobile adset-row" rowSpan="2"></td>
                            <td id="title" className="adset-box view-on-mobile" colSpan="3" onClick={handleExpand}>
                                <div className="adsets-wrapper">
                                    {activeTab !== 'ads' && <Checkbox checked={tickedList[key]} onClick={handleCheck}></Checkbox>}
                                    {data.isActive ? <Badge status="success" /> : <Badge status="default" />}
                                    {data.name}
                                </div>
                            </td>
                            <td className="view-on-mobile" colSpan="10" style={{ padding: 0, height: 0 }}></td>
                        </>
                    )}
                    {type === 'ads' && (
                        <>
                            <td id="title" className="ad-box view-on-desktop" colSpan="2">
                                {data.name}
                            </td>
                            <td id="utm" className="view-on-mobile ad-row" rowSpan="2"></td>
                            <td id="title" className="ad-box view-on-mobile" colSpan="3" onClick={handleExpand}>
                                <div className="adsets-wrapper">
                                    {data.isActive ? <Badge status="success" /> : <Badge status="default" />}
                                    {data.name}
                                </div>
                            </td>
                            <td className="view-on-mobile" colSpan="10" style={{ padding: 0, height: 0 }}></td>
                        </>
                    )}
                    <td className="view-on-desktop">{formatCurrency(data.totals.adspend, 2)}</td>
                    <td className="view-on-desktop">{formatCurrency(data.totals.cpp, 2)}</td>
                    <td className="view-on-desktop">{formatCurrency(data.totals.revenue, 2)}</td>
                    <td className="view-on-desktop">{data.totals.orders.toLocaleString('en-US')}</td>
                    <td className="view-on-desktop">{formatCurrency(data.totals.aov, 2)}</td>
                    <td className="view-on-desktop">{formatCurrency(data.totals.profit, 2)}</td>
                    <td className={'view-on-desktop ' + (data.totals.roas >= 4 ? 'perf-good' : data.totals.roas >= 2.5 ? 'perf-mid' : 'perf-low')}>{data.totals.roas.toFixed(2)}</td>
                    <td className={'view-on-desktop v2-score ' + (data.totals.scores.score >= 90 ? 'perf-good' : data.totals.scores.score >= 70 ? 'perf-mid' : 'perf-low')}>{data.totals.scores.score.toFixed(0)}</td>
                    <td className="view-on-desktop">{data.totals.sessions.toLocaleString('en-US')}</td>
                    <td className="view-on-desktop">{data.totals.scores.conversionRate.toFixed(1)}%</td>
                    <td className="view-on-desktop">{data.totals.addToCarts.toLocaleString('en-US')}</td>
                    <td className="view-on-desktop">{data.totals.scores.addToCartConversionRate.toFixed(0)}%</td>
                    <td className="view-on-desktop">{data.totals.scores.itemsPerCustomer.toFixed(1)}</td>
                </tr>
                <tr
                    className={
                        (type === 'campaigns' ? (activeTab === 'campaigns' && tickedList[key] ? 'campaign-row-sel' : 'campaign-row') : type === 'adsets' ? 'adset-row' : 'ad-row') +
                        ' view-on-mobile data-show'
                    }>
                    <td>{formatCurrency(data.totals.adspend, 2)}</td>
                    <td>{formatCurrency(data.totals.cpp, 2)}</td>
                    <td>{formatCurrency(data.totals.revenue, 2)}</td>
                    <td>{data.totals.orders.toLocaleString('en-US')}</td>
                    <td>{formatCurrency(data.totals.aov, 2)}</td>
                    <td>{formatCurrency(data.totals.profit, 2)}</td>
                    <td>{data.totals.roas.toFixed(2)}</td>
                    <td>{data.totals.scores.score.toFixed(0)}</td>
                    <td>{data.totals.sessions.toLocaleString('en-US')}</td>
                    <td>{data.totals.scores.conversionRate.toFixed(1)}%</td>
                    <td>{data.totals.addToCarts.toLocaleString('en-US')}</td>
                    <td>{data.totals.scores.addToCartConversionRate.toFixed(0)}%</td>
                    <td>{data.totals.scores.itemsPerCustomer.toFixed(1)}</td>
                </tr>
            </>
        )
    );
};

const AdsManagerBody = ({ activeTab, resultData }) => {
    const [tickedList, setTickedList] = useState({});
    const [expandList, setExpandList] = useState({});

    // calculates totals of arbitrary (filtered) data
    const calculateScreenTotals = (_selectedCampaigns) => {
        let totals = {
            spend: 0,
            revenue: 0,
            profit: 0,
            items: 0,
            orders: 0,
            pageview: 0,
            sessions: 0,
            addToCarts: 0,
            roas: 0,
            aov: 0,
            cppTotal: 0,
            cppAvg: 0,
            conversionRate: 0,
            addToCartConversion: 0,
            addToCartConversionRate: 0,
            itemsPerCustomer: 0
        };

        if (_selectedCampaigns && _selectedCampaigns.length) {
            let numItems = _selectedCampaigns.length;
            let data = [];

            const tally = (data) => {
                totals.spend += data.totals.spend;
                totals.revenue += data.totals.revenue;
                totals.items += data.totals.items;
                totals.orders += data.totals.orders;
                totals.pageview += data.totals.pageview;
                totals.sessions += data.totals.sessions;
                totals.addToCarts += data.totals.addToCarts;
                totals.profit += data.totals.profit;
                totals.cppTotal += data.totals.cpp;
                return totals;
            };

            if (activeTab == 'campaigns') {
                // use all the given cmpaigns...
                data = _selectedCampaigns;
            } else if (activeTab == 'adsets') {
                let adsets = _selectedCampaigns.map((c) => c.adsets).flat();
                data = adsets;
            } else if (activeTab == 'ads') {
                let adsets = _selectedCampaigns.map((c) => c.adsets).flat();
                let ads = adsets.map((a) => a.ads).flat();
                data = ads;
            }

            data.forEach((c) => tally(c));

            totals.spend = orZero(totals.spend.toFixed(2));
            totals.profit = orZero(totals.profit.toFixed(2));
            totals.cppTotal = orZero(totals.cppTotal.toFixed(2));
            totals.cpp = orZero((totals.spend / totals.orders).toFixed(2));
            totals.aov = orZero((totals.revenue / totals.orders).toFixed(2));
            totals.roas = orZero((totals.revenue / totals.spend).toFixed(2));
            totals.conversionRate = orZero(totals.orders / totals.sessions) * 100;
            totals.addToCartConversionRate = orZero(totals.items / totals.addToCarts) * 100;
            totals.itemsPerCustomer = orZero(totals.items / totals.orders);
        }

        return totals;
    };

    const dataTotals = calculateScreenTotals(resultData);

    const renderTableBody = () => (
        <tbody>
            {activeTab === 'campaigns' &&
                resultData.map((data, idx) => (
                    <React.Fragment key={getKey('campaigns', data)}>
                        {renderRow(
                            activeTab,
                            'campaigns',
                            data,
                            getKey('campaigns', data),
                            expandList,
                            setExpandList,
                            tickedList,
                            setTickedList,
                            // resultData.filter(item => expandList[getKey('campaigns', item)]).length > 0 ? -1 : idx
                            idx
                        )}
                        {expandList[getKey('campaigns', data)] &&
                            data.adsets.map((adsetData) => (
                                <React.Fragment key={getKey('adsets', adsetData)}>
                                    {renderRow(activeTab, 'adsets', adsetData, getKey('adsets', adsetData), expandList, setExpandList, tickedList, setTickedList)}
                                    {expandList[getKey('adsets', adsetData)] &&
                                        adsetData.ads.map((adData) => (
                                            <React.Fragment key={getKey('ads', adData)}>
                                                {renderRow(activeTab, 'ads', adData, getKey('ads', adData), expandList, setExpandList, tickedList, setTickedList)}
                                            </React.Fragment>
                                        ))}
                                </React.Fragment>
                            ))}
                    </React.Fragment>
                ))}
            {activeTab === 'adsets' &&
                resultData.map((data, idx) => (
                    <React.Fragment key={getKey('campaigns', data)}>
                        {(!resultData.filter((cam) => tickedList[getKey('campaigns', cam)]).length || tickedList[getKey('campaigns', data)]) && (
                            <>
                                {renderRow(activeTab, 'campaigns', data, getKey('campaigns', data), expandList, setExpandList, tickedList, setTickedList, idx)}
                                {data.adsets.map((adsetData) => (
                                    <React.Fragment key={getKey('adsets', adsetData)}>
                                        {renderRow(activeTab, 'adsets', adsetData, getKey('adsets', adsetData), expandList, setExpandList, tickedList, setTickedList)}
                                        {expandList[getKey('adsets', adsetData)] &&
                                            adsetData.ads.map((adData) => (
                                                <React.Fragment key={getKey('ads', adData)}>
                                                    {renderRow(activeTab, 'ads', adData, getKey('ads', adData), expandList, setExpandList, tickedList, setTickedList)}
                                                </React.Fragment>
                                            ))}
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                    </React.Fragment>
                ))}
            {activeTab === 'ads' &&
                resultData.map((data, idx) => (
                    <React.Fragment key={getKey('campaigns', data)}>
                        {(!resultData.filter((cam) => cam.adsets.filter((item) => tickedList[getKey('adsets', item)]).length).length ||
                            data.adsets.filter((item) => tickedList[getKey('adsets', item)]).length !== 0) && (
                            <>
                                {renderRow(activeTab, 'campaigns', data, getKey('campaigns', data), expandList, setExpandList, tickedList, setTickedList, idx)}
                                {data.adsets.map((adsetData) => (
                                    <React.Fragment key={getKey('adsets', adsetData)}>
                                        {(tickedList[getKey('adsets', adsetData)] || !data.adsets.filter((item) => tickedList[getKey('adsets', item)]).length) && (
                                            <>
                                                {renderRow(activeTab, 'adsets', adsetData, getKey('adsets', adsetData), expandList, setExpandList, tickedList, setTickedList)}
                                                {adsetData.ads.map((adData) => (
                                                    <React.Fragment key={getKey('ads', adData)}>
                                                        {renderRow(activeTab, 'ads', adData, getKey('ads', adData), expandList, setExpandList, tickedList, setTickedList)}
                                                    </React.Fragment>
                                                ))}
                                            </>
                                        )}
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                    </React.Fragment>
                ))}
        </tbody>
    );

    return (
        <div className="ads-manager-body">
            <div className="table-wrapper">
                <table className={`table-${activeTab} view-on-desktop`} style={{ width: '100%' }}>
                    <thead>
                        <tr className="main-column">
                            <th colSpan="2"></th>
                            <th id="costs" colSpan="2">
                                Costs
                            </th>
                            <th id="revenue" colSpan="3">
                                Revenue
                            </th>
                            <th id="profit" colSpan="2">
                                Profit
                            </th>
                            <th id="traffic-quality" colSpan="6">
                                Traffic Quality
                            </th>
                        </tr>
                        <tr className="sub-column">
                            <th id="index"></th>
                            {activeTab === 'campaigns' && <th id="title">Campaign</th>}
                            {activeTab === 'adsets' && <th id="title">Adset</th>}
                            {activeTab === 'ads' && <th id="title">Ad</th>}

                            {columns.map((column) => (
                                <th key={column.key} id={column.key}>
                                    {column.title}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    {renderTableBody()}
                    <tfoot>
                        <tr>
                            <td id="index"></td>
                            <td id="title">
                                {activeTab == 'campaigns' && `Total of ${resultData.length} Campaigns`}
                                {activeTab == 'adsets' &&
                                    `Total of ${(resultData.filter((cam) => tickedList[getKey('campaigns', cam)]).length !== 0
                                        ? resultData.filter((cam) => tickedList[getKey('campaigns', cam)])
                                        : resultData
                                    ).reduce((_p, _c) => {
                                        return _p + _c.adsets.length;
                                    }, 0)} Adsets`}
                                {activeTab == 'ads' &&
                                    `Total of ${(resultData.filter((cam) => tickedList[getKey('campaigns', cam)]).length !== 0
                                        ? resultData.filter((cam) => tickedList[getKey('campaigns', cam)])
                                        : resultData
                                    ).reduce((_p, _c) => {
                                        return (
                                            _p +
                                            _c.adsets.reduce((_p2, _c2) => {
                                                return _p2 + _c2.ads.length;
                                            }, 0)
                                        );
                                    }, 0)} Ads`}
                            </td>
                            <td id="spend">{formatCurrency(dataTotals.spend, 2)}</td>
                            <td id="cpp">{formatCurrency(dataTotals.cpp, 2)}</td>
                            <td id="revenue">{formatCurrency(dataTotals.revenue, 2)}</td>
                            <td id="orders">{dataTotals.orders.toLocaleString('en-US')}</td>
                            <td id="aov">{formatCurrency(dataTotals.aov, 2)}</td>
                            <td id="profit">{formatCurrency(dataTotals.profit, 2)}</td>
                            <td id="roas">{dataTotals.roas}</td>
                            <td id="score">100</td>
                            <td id="sessions">{dataTotals.sessions.toLocaleString('en-US')}</td>
                            <td id="conversion">{dataTotals.conversionRate.toFixed(1)}%</td>
                            <td id="atos">{dataTotals.addToCarts.toLocaleString('en-US')}</td>
                            <td id="atc-conv">{dataTotals.addToCartConversionRate.toFixed(0)}%</td>
                            <td id="items-cust">{dataTotals.itemsPerCustomer.toFixed(1)}</td>
                        </tr>
                    </tfoot>
                </table>
                <table className={`table-${activeTab} view-on-mobile`} style={{ width: '100%' }}>
                    <thead>
                        <tr className="sub-column">
                            <th id="index"></th>
                            {columns.map((column) => (
                                <th key={column.key} id={column.key}>
                                    {column.title}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    {renderTableBody()}
                    <tfoot>
                        <tr>
                            <td id="index"></td>
                            <td id="spend">{formatCurrency(dataTotals.spend, 2)}</td>
                            <td id="cpp">{formatCurrency(dataTotals.cpp, 2)}</td>
                            <td id="revenue">{formatCurrency(dataTotals.revenue, 2)}</td>
                            <td id="orders">{dataTotals.orders.toLocaleString('en-US')}</td>
                            <td id="aov">{formatCurrency(dataTotals.aov, 2)}</td>
                            <td id="profit">{formatCurrency(dataTotals.profit, 2)}</td>
                            <td id="roas">{dataTotals.roas}</td>
                            <td id="score">100</td>
                            <td id="sessions">{dataTotals.sessions.toLocaleString('en-US')}</td>
                            <td id="conversion">{dataTotals.conversionRate.toFixed(1)}%</td>
                            <td id="atos">{dataTotals.addToCarts.toLocaleString('en-US')}</td>
                            <td id="atc-conv">{dataTotals.addToCartConversionRate.toFixed(0)}%</td>
                            <td id="items-cust">{dataTotals.itemsPerCustomer.toFixed(1)}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export default AdsManagerBody;
